import type { Directive, DirectiveBinding } from "vue";
import { canShowAction } from "@shared/utils/permission";

/** v-permission="'admin.account.role.create'"：按钮层未展示则移除节点 */
export const permissionDirective: Directive<HTMLElement, string | undefined> = {
    mounted(el: HTMLElement, binding: DirectiveBinding<string | undefined>) {
        const code = binding.value;
        if (typeof code === "string" && code && !canShowAction(code)) {
            el.parentNode?.removeChild(el);
        }
    },
};
